import { Box, Center, Flex, Heading, Text, useColorModeValue } from "@chakra-ui/react";
import Logo from "../../../assets/img/logo/Byrd_Logo.png";

export default function Register() {

    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";
  return (
    <Center>
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w="100%"
        mx={{ base: "auto", lg: "0px" }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "0px", md: "8vh" }}
        flexDirection="column"
      >
        <img
          src={Logo}
          alt={"Broders logo"}
          style={{ margin: "0px auto", width: 200 }}
        />
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px" mt="20px">
            Criar Conta
          </Heading>
          <Text
            mb="36px"
            ms="4px"
            color={textColorSecondary}
            fontWeight="400"
            fontSize="md"
          >
            Preencha as informações abaixo
          </Text>
        </Box>
      </Flex>
    </Center>
  );
}
